export default "__VITE_ASSET__DrWhXHI9__"